module.exports = __webpack_public_path__ + "static/media/logout.a92eaf30.svg";